import { Box, Typography } from '@mui/material';
import { useMemo } from 'react';
import { sources } from '../../../../utils/SourceUtil';
import { withSnackbar } from '../../../../utils/SnackbarHOC';
import { commonGridSx, gridLocaleText, makeGridToolbar } from '../../../../utils/gridStyles';
import { DataGrid } from '../../../../components/SortableDataGrid/SortableDataGrid';

const CustomToolbar = makeGridToolbar('Sourcing');

const Sourcing = ({ loading, sourcesIds }) => {
  const totalBySourceId = useMemo(() => {
    return (sourcesIds ?? []).reduce((acc, item) => {
      if (item.source !== null && item.source !== '') {
        acc[item.source] = item.total ?? 0;
      }
      return acc;
    }, {});
  }, [sourcesIds]);

  const rows = useMemo(() => {
    return sources.map(({ name, id }, i) => ({
      id: i,
      name,
      count: totalBySourceId[String(id)] ?? 0,
    }));
  }, [totalBySourceId]);

  const columns = [
    {
      field: 'name', headerName: 'SOURCES', flex: 1, minWidth: 200,
      renderCell: (p) => (
        <Typography sx={{ fontSize: '1rem', fontWeight: 600, color: '#0f172a', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
          {p.value || '—'}
        </Typography>
      ),
    },
    {
      field: 'count', headerName: 'DOSSIERS GÉNÉRÉS', width: 200, align: 'center', headerAlign: 'center',
      renderCell: (p) => (
        <Typography sx={{ fontSize: '1rem', fontWeight: 600, color: '#03407b' }}>
          {p.value ?? 0}
        </Typography>
      ),
    },
  ];

  return (
    <Box sx={{ borderRadius: 3, border: '1px solid #e2e8f0', height: '44vh', minHeight: 300, background: '#fff', overflow: 'hidden', display: 'flex', flexDirection: 'column', boxShadow: '0 1px 3px 0 rgb(0 0 0 / 0.04)' }}>
      <DataGrid
        key={sourcesIds?.length ?? 0}
        rows={rows}
        columns={columns}
        getRowId={(row) => row.id}
        loading={loading}
        pageSizeOptions={[50, 100]}
        disableRowSelectionOnClick
        showToolbar
        slots={{ toolbar: CustomToolbar }}
        slotProps={{ loadingOverlay: { variant: 'skeleton', noRowsVariant: 'skeleton' } }}
        localeText={gridLocaleText}
        sx={commonGridSx}
      />
    </Box>
  );
};

export default withSnackbar(Sourcing);
